module.exports = __webpack_public_path__ + "static/media/loader.ffaac6aa.gif";